import {type ClipboardEventHandler, type FocusEventHandler, useCallback, useEffect, useRef} from "react";
import {useFormContext, useWatch} from "react-hook-form";

import {DEFAULT_EMAIL_VERIFICATION_ERROR} from "../constants/error_messages";
import {EmailVerificationResponse} from "../types/EmailVerificationResponse";

const EMAIL_VERIFICATION_DEBOUNCE_MS = 400;

const emailRegex = new RegExp(`^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`);

const EMAIL_FIELD = "email" as const;

export interface UseEmailInputVerificationParams {
    verificationData: EmailVerificationResponse | undefined;
    verificationTrigger: (email: string | null) => void;
    disabled?: boolean;
    onBlur?: FocusEventHandler<HTMLInputElement>;
    onPaste?: ClipboardEventHandler<HTMLInputElement>;
}

export const useEmailInputVerification = (params: UseEmailInputVerificationParams) => {
    const {verificationData, verificationTrigger, disabled, onBlur: onBlurProp, onPaste: onPasteProp} = params;
    const {setError, clearErrors, formState, setValue, trigger} = useFormContext();
    const inputRef = useRef<HTMLInputElement | null>(null);
    const defaultEmail = formState.defaultValues?.email;
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const emailValue = useWatch({name: EMAIL_FIELD, defaultValue: ""}) as string;

    const setEmailError = (message?: string) => {
        setError(EMAIL_FIELD, {type: "onBlur", message: message || DEFAULT_EMAIL_VERIFICATION_ERROR});
    };

    const timeoutClear = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };

    useEffect(() => {
        if (!verificationData) {
            return;
        }

        if (!verificationData.valid && verificationData.extra.didyoumean) {
            setEmailError(`${DEFAULT_EMAIL_VERIFICATION_ERROR}, czy chodziło Ci o ${verificationData.extra.didyoumean}`);
            return;
        }

        if (!verificationData.valid) {
            setEmailError();
        }
    }, [verificationData]);

    useEffect(() => {
        if (disabled) {
            timeoutClear();
            return;
        }

        timeoutClear();
        timeoutRef.current = setTimeout(() => {
            void (async () => {
                // useWatch can be ahead of what Yup / submit button (isValid) have seen; align RHF then bouncer.
                const inputValue = (emailValue ?? "") as string;

                if (!inputValue) {
                    verificationTrigger(null);
                    return;
                }

                const isEmailFormat = emailRegex.test(inputValue);
                const preventVerificationTrigger = typeof defaultEmail === "string" && inputValue === defaultEmail;

                if (!isEmailFormat) {
                    verificationTrigger(null);
                    return;
                }

                if (preventVerificationTrigger) {
                    return;
                }

                setValue(EMAIL_FIELD, inputValue, {shouldValidate: true, shouldDirty: true, shouldTouch: true});
                await trigger(EMAIL_FIELD);
                clearErrors(EMAIL_FIELD);
                verificationTrigger(inputValue);
            })();
        }, EMAIL_VERIFICATION_DEBOUNCE_MS);

        return () => {
            timeoutClear();
        };
    }, [emailValue, disabled, defaultEmail, verificationTrigger, clearErrors, setValue, trigger]);

    const runEmailBlurFlow = useCallback(
        (inputValue: string) => {
            timeoutClear();

            if (EMAIL_FIELD in formState.errors) {
                clearErrors(EMAIL_FIELD);
            }

            const isEmailFormat = emailRegex.test(inputValue);

            if (!inputValue) {
                verificationTrigger(null);
                return;
            }

            if (!isEmailFormat) {
                setEmailError();
                verificationTrigger(null);
                return;
            }

            //prevent triggering validation if email is same as default (usually autofilled from user data)
            const preventVerificationTrigger = typeof defaultEmail === "string" && inputValue === defaultEmail;

            if (preventVerificationTrigger) {
                return;
            }

            verificationTrigger(inputValue);
        },
        [clearErrors, defaultEmail, formState.errors, verificationTrigger, setEmailError]
    );

    const handleBlur: FocusEventHandler<HTMLInputElement> = (event) => {
        onBlurProp?.(event);

        if (disabled) {
            return;
        }

        runEmailBlurFlow(event.currentTarget.value);
    };

    const handlePaste: ClipboardEventHandler<HTMLInputElement> = useCallback(
        (event) => {
            onPasteProp?.(event);

            if (disabled) {
                return;
            }

            setTimeout(() => {
                const el = inputRef.current;

                if (!el) {
                    return;
                }
                const value = el.value;
                setValue(EMAIL_FIELD, value, {shouldValidate: true, shouldDirty: true, shouldTouch: true});

                void (async () => {
                    await trigger(EMAIL_FIELD);
                    runEmailBlurFlow(value);
                })();
            }, 0);
        },
        [disabled, onPasteProp, runEmailBlurFlow, setValue, trigger]
    );

    return {handleBlur, handlePaste, inputRef};
};
import {type ClipboardEventHandler, type FocusEventHandler, useCallback, useEffect, useRef} from "react";
import {useFormContext, useWatch} from "react-hook-form";

import {DEFAULT_EMAIL_VERIFICATION_ERROR} from "../constants/error_messages";
import {EmailVerificationResponse} from "../types/EmailVerificationResponse";

const EMAIL_VERIFICATION_DEBOUNCE_MS = 400;

const emailRegex = new RegExp(`^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`);

const EMAIL_FIELD = "email" as const;

export interface UseEmailInputVerificationParams {
    verificationData: EmailVerificationResponse | undefined;
    verificationTrigger: (email: string | null) => void;
    disabled?: boolean;
    onBlur?: FocusEventHandler<HTMLInputElement>;
    onPaste?: ClipboardEventHandler<HTMLInputElement>;
}

export const useEmailInputVerification = (params: UseEmailInputVerificationParams) => {
    const {verificationData, verificationTrigger, disabled, onBlur: onBlurProp, onPaste: onPasteProp} = params;
    const {setError, clearErrors, formState, setValue, trigger} = useFormContext();
    const inputRef = useRef<HTMLInputElement | null>(null);
    const defaultEmail = formState.defaultValues?.email;
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const emailValue = useWatch({name: EMAIL_FIELD, defaultValue: ""}) as string;

    const setEmailError = (message?: string) => {
        setError(EMAIL_FIELD, {type: "onBlur", message: message || DEFAULT_EMAIL_VERIFICATION_ERROR});
    };

    const timeoutClear = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };

    useEffect(() => {
        if (!verificationData) {
            return;
        }

        if (!verificationData.valid && verificationData.extra.didyoumean) {
            setEmailError(`${DEFAULT_EMAIL_VERIFICATION_ERROR}, czy chodziło Ci o ${verificationData.extra.didyoumean}`);
            return;
        }

        if (!verificationData.valid) {
            setEmailError();
        }
    }, [verificationData]);

    useEffect(() => {
        if (disabled) {
            timeoutClear();
            return;
        }

        timeoutClear();
        timeoutRef.current = setTimeout(() => {
            void (async () => {
                // useWatch can be ahead of what Yup / submit button (isValid) have seen; align RHF then bouncer.
                const inputValue = (emailValue ?? "") as string;

                if (!inputValue) {
                    verificationTrigger(null);
                    return;
                }

                const isEmailFormat = emailRegex.test(inputValue);
                const preventVerificationTrigger = typeof defaultEmail === "string" && inputValue === defaultEmail;

                if (!isEmailFormat) {
                    verificationTrigger(null);
                    return;
                }

                if (preventVerificationTrigger) {
                    return;
                }

                setValue(EMAIL_FIELD, inputValue, {shouldValidate: true, shouldDirty: true, shouldTouch: true});
                await trigger(EMAIL_FIELD);
                clearErrors(EMAIL_FIELD);
                verificationTrigger(inputValue);
            })();
        }, EMAIL_VERIFICATION_DEBOUNCE_MS);

        return () => {
            timeoutClear();
        };
    }, [emailValue, disabled, defaultEmail, verificationTrigger, clearErrors, setValue, trigger]);

    const runEmailBlurFlow = useCallback(
        (inputValue: string) => {
            timeoutClear();

            if (EMAIL_FIELD in formState.errors) {
                clearErrors(EMAIL_FIELD);
            }

            const isEmailFormat = emailRegex.test(inputValue);

            if (!inputValue) {
                verificationTrigger(null);
                return;
            }

            if (!isEmailFormat) {
                setEmailError();
                verificationTrigger(null);
                return;
            }

            //prevent triggering validation if email is same as default (usually autofilled from user data)
            const preventVerificationTrigger = typeof defaultEmail === "string" && inputValue === defaultEmail;

            if (preventVerificationTrigger) {
                return;
            }

            verificationTrigger(inputValue);
        },
        [clearErrors, defaultEmail, formState.errors, verificationTrigger, setEmailError]
    );

    const handleBlur: FocusEventHandler<HTMLInputElement> = (event) => {
        onBlurProp?.(event);

        if (disabled) {
            return;
        }

        runEmailBlurFlow(event.currentTarget.value);
    };

    const handlePaste: ClipboardEventHandler<HTMLInputElement> = useCallback(
        (event) => {
            onPasteProp?.(event);

            if (disabled) {
                return;
            }

            setTimeout(() => {
                const el = inputRef.current;

                if (!el) {
                    return;
                }
                const value = el.value;
                setValue(EMAIL_FIELD, value, {shouldValidate: true, shouldDirty: true, shouldTouch: true});

                void (async () => {
                    await trigger(EMAIL_FIELD);
                    runEmailBlurFlow(value);
                })();
            }, 0);
        },
        [disabled, onPasteProp, runEmailBlurFlow, setValue, trigger]
    );

    return {handleBlur, handlePaste, inputRef};
};
